export default {"src":"/_next/static/media/cashapp-logo.da706aa1.svg","height":28,"width":28};